// @flow

import crypto from 'crypto';
import {
  escape as base64Escape
} from 'base64-url';
import {
  GuideError
} from './errors';
import type {
  ToGuideType
} from './types';

/**
 * @param initializationVectorValue Initialization vector. Must be at least 128 characters long.
 * @param namespace A namespace of the GUID (e.g. company name or the application name).
 * @param type A resource type name (e.g. article).
 */
const toGuide: ToGuideType = (initializationVectorValue, namespace, type, id) => {
  if (initializationVectorValue.length !== 128) {
    throw new GuideError('Initialization vector must be at least 128 characters long.');
  }

  const cipher = crypto.createCipher('aes-256-gcm', initializationVectorValue);

  const payload = JSON.stringify({
    id,
    namespace,
    type
  });

  const encrypted = Buffer.concat([
    cipher.update(payload, 'utf8'),
    cipher.final()
  ]);

  const tag = cipher.getAuthTag();

  const guide = Buffer.concat([
    tag,
    encrypted
  ]);

  return base64Escape(guide.toString('base64'));
};

export default toGuide;
